import axios from "axios";

const state = {
    acks: [],
    ordermanageapi: "https://ordermanage.spacesaver.com",
    token: localStorage.getItem("SSCUSER"),
};

const getters = {
    getACKS: (state) => {
        return state.acks;
    },
    getACKS_LENGTH: (state) => {
        return state.acks.length;
    }
};

const actions = {};

const mutations = {
    SET_ACK_LIST(state) {
        let axiosConfig = {
            headers: {
                Authorization: "Bearer " + state.token,
            },
        };
        //console.log("started Vuex AC List");
        //console.log(process.env.VUE_APP_ORDER_MANAGE_API);
        return axios
            .get(process.env.VUE_APP_ORDER_MANAGE_API + `/unprinted?ac=${state.user.ACId[0]}&type=ack`, axiosConfig)
            .then((response) => {
                //console.log(response);
                state.acks = response.data;
                console.log(response.data);
            });
    },
    UPDATE_ACK_LIST(state, data) {
        //console.log('trying to update in vuex');
        //data.sort((a, b) => (a.acName > b.acName) ? 1 : -1);


        //var filtered = data.filter(filter_acs);
        state.acks = data;
        //console.log(state.acList)
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}